<template>
  <div class="real-members">
    <div class="real-members__container">
      <div class="real-members__container__header">
        <h2 class="real-members__container__header--title">
          {{ t('b2b__landing_page__real_members__title') }}
        </h2>
      </div>
      <div class="real-members__container__cards">
        <div
          v-for="({ title, author }, index) in cards"
          :key="index"
          class="real-members__container__cards--card"
        >
          <p class="kds-typography-paragraph-large">{{ title }}</p>
          <p
            class="kds-typography-title-small"
            v-html="author"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'petite-vue-i18n'

const { t } = useI18n()

const cards = computed(() => [
  {
    title: t('b2b__landing_page__real_members__card_one__title'),
    author: t('b2b__landing_page__real_members__card_one__author'),
  },
  {
    title: t('b2b__landing_page__real_members__card_two__title'),
    author: t('b2b__landing_page__real_members__card_two__author'),
  },
  {
    title: t('b2b__landing_page__real_members__card_three__title'),
    author: t('b2b__landing_page__real_members__card_three__author'),
  },
])
</script>

<style lang="scss" scoped>
.real-members {
  padding: 40px 10px;

  @include media-up(lg) {
    padding: 96px 10px;
  }

  &__container {
    @extend %container;
    margin: auto;

    &__header {
      @include flex-container(column, center, md, center);
      @include margin(xxl, bottom);

      &--title {
        @include kds-typography-display-small;
        text-align: center;

        @include media-up(md) {
          @include kds-typography-display-medium;
        }
      }
    }

    &__cards {
      display: grid;
      gap: 32px;
      grid-template-columns: 1fr;

      @include media-up(lg) {
        grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
      }

      &--card {
        position: relative;
        padding: 40px;
        border-radius: 16px;
        @include flex-container(column, flex-start, lg);

        &:before {
          position: absolute;
          content: '\201C';
          font-size: 7em;
          top: 22px;
        }

        &:nth-child(1) {
          background: $kds-color-background-green-subtle;

          &:before {
            color: $kds-color-background-green-accent;
          }
        }

        &:nth-child(2) {
          background: $kds-color-background-yellow-subtle;

          &:before {
            color: $kds-color-background-yellow-accent;
          }
        }

        &:nth-child(3) {
          background: $kds-color-background-purple-subtle;

          &:before {
            color: $kds-color-background-purple-accent;
          }
        }
      }
    }
  }
}
</style>
